import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { ButtonSize, ButtonStyle } from '@constants/button/1.0';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MessageType } from '@constants/message/1.0';
import { NgIf, NgFor } from '@angular/common';
import { MessageComponent } from '../../message/1.0/message.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatInput } from '@angular/material/input';
import { ButtonComponent } from '../../button/1.0/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'txp-store-ordering-deactivate-dialog',
  templateUrl: './store-ordering-deactivate-dialog.html',
  styleUrls: ['./store-ordering-deactivate-dialog.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    NgIf,
    MessageComponent,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    NgFor,
    MatOption,
    MatError,
    MatInput,
    MatDialogActions,
    ButtonComponent,
    TranslateModule,
  ],
})
export class StoreOrderingDeactivateDialogComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;

  buttonStyle = ButtonStyle;
  buttonSize = ButtonSize;
  defaultFormValue: any;
  messageType = MessageType; // expose enum to template
  showError = false;
  searchDone = false;
  form: UntypedFormGroup;
  isLoading = false;
  reasons = [
    'noDriver',
    'noInternet',
    'noBroiler',
    'externalEvent',
    'badWeather',
    'noPower',
    'posOutage',
    'holiday',
    'tillsterTesting',
    'other',
  ];
  showFormError = false;

  constructor(
    private dialogRef: MatDialogRef<StoreOrderingDeactivateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string; suffix: string },

    private formBuilder: UntypedFormBuilder,
  ) {
    this.form = this.formBuilder.group({
      reason: new UntypedFormControl('', Validators.required),
      details: new UntypedFormControl(null, Validators.required),
    });
  }

  ngOnInit() {
    this.form.get('reason').valueChanges.subscribe((reason) => {
      if (reason === 'other') {
        this.form.get('details').setValidators([Validators.required]);
      } else {
        this.form.get('details').clearValidators();
      }
      this.form.get('details').updateValueAndValidity();
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      this.showFormError = true;
      return;
    }

    if (this.form.value.reason !== 'other') {
      delete this.form.value.details;
    }

    this.dialogRef.close(this.form.value);
  }
}
